import { Col, Row, Avatar, Card, Tag, Space } from 'antd';
import DefaultImage from '../../../../../assets/images/ICONO-AZUL-100x100.png';
import { getFullCellphone } from '../../../../../util';
import { stringDate } from '../../../../../util/formatTime';
import { RenderStatus } from '../../../../uiComponents';
import {
  appointmentTags,
  customerConst,
  dictionaryScaleConst,
  strikeTags,
} from '../../../../../constants';

export const CustomerMainData = ({ data }) => {
  const mobileContact = data?.mobilePhone ? data : data?.tutor;
  const isPhoneVerified = Boolean(mobileContact?.isPhoneVerified);
  const isEmailVerified = Boolean(data?.isEmailVerified);

  const finishedCount = Number(data?.finishedAppointments || 0);
  const strikes = Number(data?.cancellations || 0);
  const wasBanned = data?.blackList || data?.unbanned;

  const getCustomerTypeTag = () => {
    if (finishedCount === 0) return <Tag color="orange">{strikeTags.new}</Tag>;
    if (finishedCount >= 1 && finishedCount <= 14)
      return <Tag color="green">{strikeTags.active}</Tag>;
    if (finishedCount >= 15 && finishedCount <= 29)
      return <Tag color="blue">{strikeTags.recurrent}</Tag>;
    return <Tag color="purple">{strikeTags.good}</Tag>;
  };

  const getBehaviorTags = () => {
    const tags = [];

    if (strikes >= 1) {
      tags.push(
        <Tag key="strikes1" color="gold">
          {appointmentTags.unattendance}
        </Tag>
      );
    }

    if (strikes >= 3) {
      tags.push(
        <Tag key="strikes3" color="orange">
          {appointmentTags.recurrentUnattendance}
        </Tag>
      );
    }

    if (wasBanned) {
      tags.push(
        <Tag key="ban" color="red">
          {appointmentTags.banHistory}
        </Tag>
      );
    }

    return tags.length ? tags : '-';
  };

  return (
    <Card
      bordered={true}
      cover={
        <Avatar
          className="avatar"
          alt="..."
          src={
            data?.photo?.name
              ? `${process.env.REACT_APP_API}/v1/customer/avatar/${data?.photo?.name}`
              : DefaultImage
          }
        />
      }
    >
      <Row className="row">
        <Col span={8}>
          <h5 className="strong">Id de Cliente</h5>
        </Col>
        <Col span={16}>{`${data?.customerId}`}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h5 className="strong">Nombre</h5>
        </Col>
        <Col
          span={16}
        >{`${data?.name?.toUpperCase()} ${data?.lastName?.toUpperCase()} ${
          data?.motherLastName?.toUpperCase() || ' '
        }`}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h5 className="strong">Tipo cliente</h5>
        </Col>
        <Col span={16}>{getCustomerTypeTag()}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h5 className="strong">Comportamiento</h5>
        </Col>
        <Col span={16}>
          <Space wrap>{getBehaviorTags()}</Space>
        </Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h5 className="strong">Sucursal de registro</h5>
        </Col>
        <Col span={16}>{`${data?.registryBranch || '-'}`}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h5 className="strong">{customerConst.contactLabels.mobilePhone}</h5>
        </Col>
        <Col span={16}>{getFullCellphone(mobileContact)}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h5 className="strong">
            {customerConst.contactLabels.phoneVerified}
          </h5>
        </Col>
        <Col span={16}>
          <Tag color={isPhoneVerified ? 'green' : 'red'}>
            {isPhoneVerified
              ? customerConst.contactLabels.verified
              : customerConst.contactLabels.notVerified}
          </Tag>
        </Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h5 className="strong">Fecha de nacimiento</h5>
        </Col>
        <Col span={16}>{stringDate(data?.birthday) || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h5 className="strong">{customerConst.contactLabels.email}</h5>
        </Col>
        <Col span={16}>{data?.email || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h5 className="strong">
            {customerConst.contactLabels.emailVerified}
          </h5>
        </Col>
        <Col span={16}>
          <Tag color={isEmailVerified ? 'green' : 'red'}>
            {isEmailVerified
              ? customerConst.contactLabels.verified
              : customerConst.contactLabels.notVerified}
          </Tag>
        </Col>
      </Row>

      {data?.isTutor === true && (
        <Row className="row">
          <Col span={8}>
            <h5 className="strong">Tutor</h5>
          </Col>
          <Col span={16}>
            <Tag color="green"> Si </Tag>
          </Col>
        </Row>
      )}

      <Row className="row">
        <Col span={8}>
          <h5 className="strong">Status</h5>
        </Col>
        <Col span={16}>
          <RenderStatus data={data} />
        </Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h5 className="strong">Lista Negra</h5>
        </Col>
        <Col span={16}>
          <Tag color={data?.blackList ? 'red' : 'green'}>
            {data?.blackList ? 'Si' : 'No'}
          </Tag>
        </Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h5 className="strong">Puntos</h5>
        </Col>
        <Col span={16}>
          <Tag>{data?.points}</Tag>
        </Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h5 className="strong">Escala de lealtad</h5>
        </Col>
        <Col span={16}>{dictionaryScaleConst[data?.loyaltyScale]}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h5 className="strong">Strikes</h5>
        </Col>
        <Col span={16}>{data?.cancellations}</Col>
      </Row>
    </Card>
  );
};
